import { Route, Routes, useLocation } from 'react-router-dom';

import { RouterComponentWrapper } from '@/hoc/routerComponentWrapper';
import { EditBillScreen } from '@/screens/edit-bill/EditBill.screen';

export const BillsRoute = () => {
  const { state } = useLocation();
  const { returnUrl } = (state as { returnUrl?: string }) || {};
  return (
    <Routes>
      <Route
        path="/:id"
        element={
          <RouterComponentWrapper componentProps={{ id: { _pathParam: 'id' }, returnUrl }} Component={EditBillScreen} />
        }
      />
    </Routes>
  );
};
